module.exports = __webpack_public_path__ + "components/flag/static/square/tr-a56c1d06076c9daef64b10ac69bd23b8.svg";